/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_CloseInputs */



/**
* | output |
* | --- |
* | "Close AI Assistant" |
*
* @param {Assistant_CloseInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_close = /** @type {((inputs?: Assistant_CloseInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_CloseInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fermer l'assistant IA")
	if (locale === "de") return /** @type {LocalizedString} */ ("Schließen Sie den KI-Assistenten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Assistente AI chiuso")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Закрыть ИИ-помощника")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cerrar asistente de IA")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("近距离人工智能助手")
	if (locale === "ja") return /** @type {LocalizedString} */ ("AIアシスタントを閉じる")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एआई सहायक को बंद करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fechar Assistente de IA")
	return /** @type {LocalizedString} */ ("Close AI Assistant")
});